import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fw-select-base fw-select-base__week" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwSelect = _resolveComponent("FwSelect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FwSelect, {
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        label: "text",
        options: _ctx.options,
        canNotDelete: true,
        type: "filter",
        searchable: false,
        onInput: _cache[1] || (_cache[1] = (selectValue) => _ctx.onInput(selectValue))
      }, null, 8, ["modelValue", "options"])
    ])
  ]))
}